
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/growthhack",
      function () {
        return require("private-next-pages/download/growthhack/index.tsx");
      }
    ]);
  